import { render, staticRenderFns } from "./OpenTrades.vue?vue&type=template&id=4b66a296&"
import script from "./OpenTrades.vue?vue&type=script&lang=js&"
export * from "./OpenTrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports